import { Map } from 'immutable';
import { actions } from './actions';

const initialState = new Map({
  passcodeValidated: false,
  adminPasscode: '',
  adminFirstClockIn: false,
  magicLink: '',
});

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.SET_PASSCODE_VALIDATED:
      return state.set('passcodeValidated', value);
    case actions.SET_ADMIN_PASSCODE:
      return state.set('adminPasscode', value);
    case actions.SET_FIRST_TIME_CLOCKING_IN:
      return state.set('adminFirstClockIn', value);
    case actions.SET_MAGIC_LINK:
      return state.set('magicLink', value);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/config/reducer.js